import { AccordionItem, Text, List } from 'braid-design-system';
export const ApiVersioning = () => (
  <AccordionItem id="api-versioning" label="API Versioning">
    <List type="number" start={37}>
      <Text>
        Any changes to the SEEK API shall be announced in the Release notes
        section of the applicable SEEK Developer Site. We will provide you with
        30 days’ notice of any changes that, if not implemented, will break your
        integration with the SEEK API.
      </Text>
    </List>
  </AccordionItem>
);
